<script>
import LandingPageMixin from '@/mixins/landingpage'

export default {
  name: 'LandingPageContiki',
  mixins: [ LandingPageMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false
    }
  },
  methods: {
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn">
     <div class="menu-itinerary row">
        <div class="col-md-12 col-12">
        <div class="container-menu paddig-container">
          <div class="cover-logo">
            <a class="navbar-brand" href="#">
              <span class="logo">
                <img class="logo-itinerary" src="/landingpages/contiki/img/logo.png" alt="Logo">
              </span>
            </a>
          </div>
          <!-- Begin of menu icon toggler -->
          <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu">
            <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
              <span class="bars">
                <span class="bar1"></span>
                <span class="bar2"></span>
                <span class="bar3"></span>
              </span>
            </span>
          </button>
        </div>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
          <img src="/landingpages/contiki/img/logo.png" alt="Logo" class="light-logo menu-logo">
          <div class="divider-menu">
          </div>
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('highlight')">Inclusions</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': 'url(/landingpages/contiki/img/bg-style-1.jpg)'}]">

        <div class="overlay-home"></div>
        <div class="section-wrapper animated delay-1s slow fadeIn home-flex">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description text-center">
                  <div class="cover-slider-description">
                   <div class="cover-calendar-location">
                      <h1 class="cover-header-description-title1">
                            <span>
                                <i class="icon fa fa-calendar"></i>
                                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                                <i class="fa fa-arrow-right ml-3 mr-2"></i>
                            </span>
                            <span class="date-block">
                              <i class="icon fa fa-calendar"></i>
                              <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}
                            </span>
                        </span>
                        <span class="ml-3 location-cover" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                            <i class="fa fa-map-marker"></i>
                            <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}
                            </span>
                        </span>
                      </h1>

                    </div>
                    <div class="cover-header-description-title2" v-if="d && d.consumer_section">
                       {{ d.consumer_section.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                        <span>{{ d.consumer_section.trip_subtitle }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown">
            <a class="down" @click="scrollMeTo('letter')">
              <span class="icon"></span>
              <span class="txt">DESCRIPTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto bg-level-1" data-section="letter" id="letter">
        <div class="section-wrapper with-margin">
            <div class="tour_host_box text-right px-4" v-if="d.consumer_section.tour_host_photo">
              <img class="tour_host_photo" :src="d.consumer_section.tour_host_photo"/>
              <div class="tour_host_info text-left">
                <p class="tour_host_name" v-if="d.consumer_section.tour_host_name" v-html="d.consumer_section.tour_host_name"></p>
                <p v-if="d.consumer_section.tour_host_position" v-html="d.consumer_section.tour_host_position"></p>
              </div>
            </div>
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.consumer_section.short_description">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle text-center">
              <div class="cover-header-description-title2 title-sections scrolled mb-4">Itinerary</div>
              <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                {{ d.consumer_section.trip_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-random grid-media-aside-text fade-3" data-section="itinerary-days" id="itinerary-days">
          <div class="col-md-6 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
            <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
              <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
              <img v-if="!day.url_image_1200_725" src="/landingpages/contiki/img/day-img.jpg"/>
              <div class="info text-center">
                <p class="day_position text-uppercase">day {{ day.startday }}</p>
                <h1 class="title-day" v-html="day.title"></h1>
                <p>
                  <i class="icon fa fa-calendar mr-2"></i>
                  <span v-if="day">{{ day.startdate | custom-date }}</span>
                </p>
                <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                  <i class="fa fa-map-marker mr-2"></i>
                  <span >{{ day.locations | custom-join('name') }}</span>
                </p>
                  <button
                    class="btn mt-3 btn-radius btn-white">
                    <div class="text">See this day</div>
                  </button>
              </div>
            </div>
          </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer bg-mark"
        data-section="highlight" id="highlight"> -->
      <div class="section bg-level-2" data-section="highlight" id="highlight"
     v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0 ||
        Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle text-center">
              <div class="cover-header-description-title2 title-sections scrolled">Inclusions</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left ">
                  <div class="wrapper-included">
                    <div class="section-info included-bg" v-if="Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
                      <h1 class="title-sections">What's Included<i class="icon fa fa-check-circle"></i></h1>
                      <div v-for="whatsinc in d.consumer_section.whatsincluded" :key="whatsinc.id">
                        <h5 class="mt-3" v-html="whatsinc.title"  v-if="whatsinc.title"></h5>
                        <ul class="mt-2">
                          <li v-for="item in whatsinc.items" :key="item.id" v-html="item.items"></li>
                        </ul>
                    </div>
                    </div>
                    <div class="section-info included-bg"  v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0">
                      <h1 class="title-sections">Experiences<i class="icon fa fa-check-circle"></i></h1>
                      <div v-for="highlight in d.consumer_section.highlights" :key="highlight.id">
                        <h5 class="mt-3" v-html="highlight.title" v-if="highlight.title"></h5>
                        <ul class="mt-2">
                          <li v-for="item in highlight.items" :key="item.id" v-html="item.items"></li>
                        </ul>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-register bg-level-1" data-section="map" id="map">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-center">
                <div class="title-desc content-white">
                  <h2 class="title-sections">Map</h2>
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off bg-level-2 no-footer" data-section="prices" id="prices">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-tittle text-center">
                  <div class="cover-header-description-title2 title-sections scrolled">Pricing</div>
                </div>
                <div class="table_pricing mb-4">
                <div class="row">
                  <div class="col-12 col-md-6 anim">
                    <div class="text-center amount-price" v-if="d && d.consumer_section">
                      <p class="display-5 anim-2">{{ d.consumer_section.twinshare_price_name }}</p>
                      <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.twinshare_price }}</h2>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 anim fluid">
                      <div class="text-center amount-price" v-if="d && d.consumer_section">
                        <p class="display-5 anim-2">{{ d.consumer_section.single_supp_price_name }}</p>
                        <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.single_supp_price }}</h2>
                      </div>
                  </div>
                </div>
                </div>
                <p class="terms">View <a href="#" @click.prevent="toggleTermsAndConditionsModal"><strong>Terms and Conditions</strong></a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div class="section fullscreen-md-off bg-fixed section-contact bg-level-1 bg-center content-white" data-section="contact" id="contact"
            :style="[secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': 'url(/landingpages/contiki/img/bg-style-2.jpg)'}]">
        <div class="section-wrapper bg-overlay with-margin">
          <div class="section-content padding-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="title-desc">
                  <h2 class="text-center title-sections">Contact Us</h2>
                </div>
                <div class="pt-1 text-center">
                   <p class="pt-4 text-center" v-if="!d.consumer_section && !d.consumer_section.company_logo">
                      Contact your Travel Agent!
                   </p>

                    <p class="pt-4 pb-4 text-center" v-if="!d.consumer_section.call_action">
                      Please send a message.
                    </p>

                    <p v-if="d.consumer_section.call_action" v-html="d.consumer_section.call_action" class="pt-0"></p>
                    <img class="tour_host_logo" v-if="d.consumer_section.company_logo" :src="d.consumer_section.company_logo"/>
                </div>
              </div>

              <div class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left">
                <div class="contact-us-box">
                  <div class="title-desc">
                    <h2 class="title-sections text-left">Drop Us a Line</h2>
                  </div>
                  <form  @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Name" v-model="name" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <input class="form-control-white" type="text" required placeholder="Your Email" v-model="email" :disabled="isSending">
                    </div>
                    <div class="form-group ">
                      <textarea class="form-control-white" type="text" required placeholder="How can we assist you with this group?" cols="10" rows="10" v-model="description" :disabled="isSending"></textarea>
                    </div>
                    <div class="form-group form-success-gone text-right mb-0 d-flex justify-content-end align-items-center">
                      <div v-if="isCompleted">{{ message }}</div>
                      <button class="btn btn-radius btn-green" type="submit" :disabled="isSending">
                        <div class="text" v-if="!isSending">Submit</div>
                        <div class="text" v-else>Sending</div>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <footer>
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/landingpages/contiki/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>

    </main>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header  section-header2">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content">
            <div class="modal-body">
              <div class="title-desc "><h3 class="h2 title-sections-2 pt-3">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 paddig-container scrollable terms-information"
               v-html="d.consumer_section.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img class="light-logo" src="/landingpages/contiki/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/landingpages/contiki/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text pl-0">
                  <div class="align-vcenter text-center">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p class="day-information" v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldown nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldown nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
